import React, { useEffect, useRef, useState } from 'react';
import { PartnersFaviconImg, CapaConnectImg, CapaFaviconImg } from '../assets';
import { CapaServiceType } from '@generated/graphql';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import { colorSet, clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { Box, IconButton, makeStyles, Fade } from '@material-ui/core';
import { Apps } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 2000,
    position: 'absolute',
    top: '61px !important',
    left: 'initial !important',
    right: '100px !important',
    transform: 'initial !important',
    [theme.breakpoints.down('md')]: {
      top: '49px !important',
      right: '16px !important'
    }
  },
  menuIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    color: colorSet.gray900,
    '&:hover': {
      backgroundColor: colorSet.gray100
    }
  },
  boxRoot: {
    color: colorSet.gray900,
    borderRadius: 4,
    backgroundColor: colorSet.gray000,
    padding: 8,
    boxShadow:
      '0px 8px 16px 2px rgba(97, 97, 97, 0.1), 0px 16px 32px 2px rgba(97, 97, 97, 0.1)'
  },
  menuWrapper: {
    display: 'flex'
  },
  menuItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: 46,
      marginBottom: 7
    },
    textAlign: 'center',
    width: 96,
    height: 96,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colorSet.gray100
    },
    borderRadius: 4,
    '& + div': {
      marginLeft: 8
    }
  }
}));

interface Props {
  handleSwitchService: (service: CapaServiceType) => Promise<string | void>;
}

const GnbCheckerBoardMenuPresenter: React.FC<Props> = ({
  handleSwitchService
}) => {
  const classes = useStyles();
  const isRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const { onInsertUserActionLogOne } = useUserActionLog();

  useEffect(() => {
    const handleClose = (e: MouseEvent): void => {
      if (isRef.current && !isRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mouseup', handleClose);
    return () => document.removeEventListener('mouseup', handleClose);
  }, [isRef]);

  const onClick = () => setOpen(!open);

  return (
    <React.Fragment>
      <div ref={isRef}>
        <IconButton
          className={clsx(classes.menuIcon, 'gnb-checkerboard-menu')}
          onClick={(e) => {
            if (e.currentTarget) {
              onInsertUserActionLogOne(
                Enum_Action_Button_Enum.Button_GNB_Checkerboard,
                CapaActivityType.ButtonClick
              );
              onClick();
            }
          }}
        >
          <Apps />
        </IconButton>

        {open && (
          <div className={classes.root}>
            <Fade in={open}>
              <Box className={classes.boxRoot}>
                <div className={classes.menuWrapper}>
                  <div
                    className={classes.menuItem}
                    onClick={() => {
                      onInsertUserActionLogOne(
                        Enum_Action_Button_Enum.Button_GNB_Checkerboard_Capa,
                        CapaActivityType.ButtonClick
                      );
                    }}
                  >
                    <img src={CapaFaviconImg} alt="capa" />
                    <CustomizedTypography variant="subtitle2">
                      캐파
                    </CustomizedTypography>
                  </div>

                  <div
                    className={classes.menuItem}
                    onClick={() => {
                      onInsertUserActionLogOne(
                        Enum_Action_Button_Enum.Button_GNB_Checkerboard_Partners,
                        CapaActivityType.ButtonClick
                      );
                      handleSwitchService(CapaServiceType.QuotationPartner);
                    }}
                  >
                    <img src={PartnersFaviconImg} alt="partners" />
                    <CustomizedTypography variant="subtitle2">
                      캐파 파트너스
                    </CustomizedTypography>
                  </div>
                  <div
                    className={classes.menuItem}
                    onClick={() => {
                      onInsertUserActionLogOne(
                        Enum_Action_Button_Enum.Button_GNB_Checkerboard_Connect,
                        CapaActivityType.ButtonClick
                      );
                      handleSwitchService(CapaServiceType.Connect);
                    }}
                  >
                    <img src={CapaConnectImg} alt="connect" />
                    <CustomizedTypography variant="subtitle2">
                      캐파 커넥트
                    </CustomizedTypography>
                  </div>
                </div>
              </Box>
            </Fade>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default GnbCheckerBoardMenuPresenter;
